/* DEVELOPER NOTE:

  Find and replace this string, '// DevComment: ' with '' if you want get some
  sweets debug messages. But you have to revert the changes for two reasons:
  1. We want to keep those lines in order to debug again.
  2. No production enviroment should have console o other test committed to
     production.

  Also, help us improve our debugging code. Thanks
*/
!function(global) {
  'use strict';

  var previousResultList = global.ResultList;

  function ResultList(options) {
    var options = options || {};
    var $container;
    var sourceTpl;
    var hbTpl;

    function init() {
      $container = options.$container;
      sourceTpl = $(options.hbtpl).html();
      hbTpl = Handlebars.compile(sourceTpl);
    }

    function render(results, resources) {
      var context = {};
      var html;
      var entry;
      // DevComment: var t0;
      // DevComment: var t1;
      // DevComment: t0 = performance.now();

      $container.empty();

      // TODO: Check for an alternative solution that includes windows resize
      if (!eeGlobal.mqDetector.isMobile()) {
        // Animation to go to the init of the page when results change
        $('html, body').animate({
          scrollTop: 0
        }, 500);
      }

      context.results = results;
      context.resources = resources;
      html = hbTpl(context);

      //TODO: Fragments
      $container.append(html);
      // DevComment: t1 = performance.now();
      // DevComment: console.warn('Render executed in ' + (t1 - t0) + ' ms.');
    }

    function cleanResults() {
      $container.empty();
    }

    init();

    return {
      render: render,
      clean: cleanResults
    }

  }

  ResultList.noConflict = function noConflict() {
    global.ResultList = previousResultList;
    return ResultList;
  };

  global.ResultList = ResultList;
}(this);
